import { Grid } from '@material-ui/core'
import { COLORS, Select } from '@monthio/react-components'
import styled from 'styled-components'

export const FormGrid = styled(Grid)`
	height: 100%;
	box-sizing: border-box;
	justify-content: space-between;
	align-items: center;
`

export const MainSectionGrid = styled(Grid)`
	width: 100%;
`

export const FinishSectionGridWrap = styled(Grid)`
	padding-top: ${(props) => props.theme.spacing(4)}px;
	width: 100%;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;

	${(props) => props.theme.breakpoints.up('md')} {
		justify-content: center;
		flex-flow: row wrap;
	}
`

export const FlowSelect = styled(Select)`
	min-width: 150px;
	.MuiSelect-root > span {
		padding: 0 8px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.MuiSelect-root {
		border-radius: 4px;
	}

	background: ${COLORS.GREY_SCALE.BACKGROUND_GREY};
	outline: 1px solid ${COLORS.BRAND_COLORS.HIGHLIGHT_BLUE};
	border-radius: 4px;
`
